import I18n from 'utils/I18n';
import { I18nPrefix } from '../constants/invite-friends-constants';

export const t = (key, params) => I18n.t(`${I18nPrefix}.${key}`, { ...params });

export default { t };
